const IBModule = () => import('@/pages/ib_module/IBModule.vue');

const routes = [
  {
    path: '/ib_portal/',
    redirect: '/ib_portal/dashboard/',
  },
  {
    path: '/ib_portal/dashboard/',
    meta: {
      title: 'IB Portal',
    },
    component: IBModule,
  },
];

export default routes;
